import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isToday, isTomorrow } from 'date-fns';

@Pipe({
  name: 'standardDateOnly',
})
export class StandardDateOnlyPipe extends DatePipe implements PipeTransform {
  public transform(value: any, format?: string, timezone?: string, locale?: string): string | null {
    if (!value) {
      return '—';
    }
    return super.transform(value, standardDateFormat(value));
  }
}

export function standardDateFormat(value: any): string {
  const asDate = new Date(value);
  let formattingText = `M/dd/yyyy`;
  if (isToday(asDate)) {
    formattingText = `'Today'`;
  } else if (isTomorrow(asDate)) {
    formattingText = `'Tomorrow'`;
  }
  return formattingText;
}
